// extracted by mini-css-extract-plugin
export default {"loading_container":"loading_loading_container__Oe5lO","lds_ripple":"loading_lds_ripple__+KujV","lds-ripple":"loading_lds-ripple__eUrFh"};